import { useEffect, useState } from 'react';
import { fetchVersionInfo } from '../api/version';

/**
 * アプリケーションのバージョン情報を取得するフック
 * コンポーネントのマウント時に1度だけバージョン情報を取得します
 * バージョンの差異を検出すると自動的にページをリロードします
 */
export const useAppVersion = () => {
  const [ version, setVersion ] = useState('unknown');
  const [ releaseDate, setReleaseDate ] = useState('');
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState<string | null>(null);
  
  // コンポーネントのマウント時に一度だけ実行
  useEffect(() => {
    const getVersion = async() => {
      try {
        setLoading(true);
        // 自動リロードを有効にしてバージョン情報を取得
        // (バージョンが変わっていれば、この関数内でページがリロードされる)
        const info = await fetchVersionInfo(true);
        setVersion(info.version);
        setReleaseDate(info.releaseDate);
        setError(null);
      } catch (err) {
        console.error('バージョン情報の取得に失敗:', err);
        setError('バージョン情報の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };
    
    getVersion();
    // 依存配列は空で、マウント時に一度だけ実行
  }, []);
  
  return {
    version,
    releaseDate,
    loading,
    error
  };
};
export default useAppVersion;
